'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComputerAffiliateBind } from '#pplx/frontend/apps/ask/analytics/ComputerAffiliateBindLoader.js';
import { useHandleSearch } from '#pplx/frontend/apps/ask/page-components/search/hooks/search.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const SearchPageMobile = Dynamic(async () => {
    const { SearchPageMobile } = await import('#pplx/frontend/apps/ask/page-components/search/search-component-mobile.js');
    return { default: SearchPageMobile };
});
const SearchComponentsMobileContent = React.memo(function SearchComponentsMobileContent() {
    const result = useHandleSearch();
    if (!result) {
        return null;
    }
    if ('component' in result) {
        return result.component;
    }
    return _jsx(SearchPageMobile, { ...result.props });
});
export const SearchComponentsMobile = React.memo(function SearchComponentsMobile() {
    return (_jsxs(_Fragment, { children: [_jsx(ComputerAffiliateBind, {}), _jsx(SearchComponentsMobileContent, {})] }));
});
//# sourceMappingURL=search-components-mobile.js.map